export default [
  /**
   * 入院办理
   * 选择就诊人
   */
  {
    path: '/admission/select',
    component: () => import('./select')
  },
  /**
   * 提交前
   */
  {
    path: '/admission/pre',
    component: () => import('./pre')
  },
  /**
   * 结果
   */
  {
    path: '/admission/result',
    component: () => import('./result')
  },
  /**
   * 设置
   */
  {
    path: '/admission/set',
    component: () => import('./set')
  },
  /**
   * 选择住院证
   */
  {
    path: '/admission/card',
    component: () => import('./card')
  },
  /**
   * 带就诊人id过来
   */
  {
    path: '/admission/before',
    component: () => import('./before')
  }
]



// WEBPACK FOOTER //
// ./src/page/admission/admission.js